(function () {
  'use strict';

  var STORAGE_KEY = 'mm_cat_views_v1';

  function matchesFuzzySearch(query, haystack) {
    if (window.MMSmartSearch) {
      return window.MMSmartSearch.matchesFuzzySearch(query, haystack);
    }
    var q = (query || '').trim().toLowerCase();
    if (!q) return true;
    return (haystack || '').toLowerCase().indexOf(q) !== -1;
  }

  function readViews() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function writeViews(views) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
    } catch (e) { /* ignore */ }
  }

  function getViewCount(views, handle) {
    var n = views[handle];
    return typeof n === 'number' && n > 0 ? n : 0;
  }

  function buildCardHaystack(card) {
    var parts = [
      card.dataset.searchIndex,
      card.dataset.title,
      card.dataset.handle,
      (card.dataset.handle || '').replace(/-/g, ' ')
    ];
    return parts.join(' ');
  }

  function initSection(root) {
    if (!root || root.dataset.mmCatInit === 'true') return;
    root.dataset.mmCatInit = 'true';

    var tabLimit = parseInt(root.dataset.tabLimit, 10) || 12;
    var sortByPopularity = root.dataset.sortPopularity !== 'false';

    var views = readViews();
    var searchInput = root.querySelector('[data-mm-cat-search]');
    var tabsTrack = root.querySelector('[data-mm-cat-tabs]');
    var groupTabsTrack = root.querySelector('[data-mm-cat-group-tabs]');
    var emptyState = root.querySelector('[data-mm-cat-empty]');
    var stickyBar = root.querySelector('[data-mm-cat-sticky]');
    var stickySentinel = root.querySelector('[data-mm-cat-sticky-sentinel]');
    var stickyPlaceholder = root.querySelector('[data-mm-cat-sticky-placeholder]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mm-cat-group]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mm-cat-card]'));

    var scrollLockUntil = 0;
    var stickyPinned = false;

    cards.forEach(function (card) {
      card.__mmCatHaystack = buildCardHaystack(card);
    });

    function getHeaderOffset() {
      var header = document.getElementById('mm-header-sticky');
      if (!header) return 0;
      return Math.ceil(header.getBoundingClientRect().height) || header.offsetHeight || 0;
    }

    function updateStickyHeight() {
      if (!stickyBar) return;
      var h = stickyBar.offsetHeight;
      root.style.setProperty('--mm-cat-sticky-h', h + 'px');
    }

    function refreshFixedTop() {
      var off = getHeaderOffset();
      root.style.setProperty('--mm-cat-fixed-top', off + 'px');
      return off;
    }

    function setStickyPinned(pin) {
      if (!stickyBar || !stickyPlaceholder) return;
      if (stickyPinned === pin) return;
      stickyPinned = pin;
      stickyBar.classList.toggle('is-pinned', pin);
      if (pin) {
        stickyPlaceholder.style.display = 'block';
        stickyPlaceholder.style.height = stickyBar.offsetHeight + 'px';
      } else {
        stickyPlaceholder.style.display = 'none';
        stickyPlaceholder.style.height = '0';
      }
      updateStickyHeight();
    }

    function updateStickyPin() {
      if (!stickyBar || !stickySentinel) return;
      var top = refreshFixedTop();
      var sentinelTop = stickySentinel.getBoundingClientRect().top;
      setStickyPinned(sentinelTop <= top + 1);
    }

    updateStickyHeight();
    refreshFixedTop();
    updateStickyPin();

    window.addEventListener('resize', function () {
      refreshFixedTop();
      updateStickyHeight();
      updateStickyPin();
    });
    window.addEventListener(
      'scroll',
      function () {
        updateStickyPin();
      },
      { passive: true }
    );

    function score(handle) {
      return getViewCount(views, handle);
    }

    function sortCardsInGroup(groupEl) {
      if (!sortByPopularity) return;
      var grid = groupEl.querySelector('[data-mm-cat-grid]');
      if (!grid) return;
      var groupCards = Array.prototype.slice.call(grid.querySelectorAll('[data-mm-cat-card]'));
      groupCards.sort(function (a, b) {
        var diff = score(b.dataset.handle) - score(a.dataset.handle);
        if (diff !== 0) return diff;
        return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      });
      groupCards.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    groups.forEach(sortCardsInGroup);

    function getActiveGroupEl() {
      if (!groupTabsTrack || !groups.length) return groups[0] || null;
      var activeBtn = groupTabsTrack.querySelector('[data-mm-cat-group-tab].is-active');
      if (activeBtn) {
        var gid = activeBtn.getAttribute('data-group-id');
        if (gid) return document.getElementById(gid) || groups[0];
      }
      return groups[0];
    }

    function buildTabs() {
      if (!tabsTrack) return;
      tabsTrack.innerHTML = '';

      var activeGroup = getActiveGroupEl();
      var tabCards = activeGroup
        ? Array.prototype.slice.call(activeGroup.querySelectorAll('[data-mm-cat-card]'))
        : cards.slice();

      if (sortByPopularity) {
        tabCards.sort(function (a, b) {
          var diff = score(b.dataset.handle) - score(a.dataset.handle);
          if (diff !== 0) return diff;
          return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        });
      }

      var visibleTabs = tabCards.filter(function (c) {
        return !c.hidden;
      });

      var limit = Math.min(tabLimit, visibleTabs.length);
      var used = visibleTabs.slice(0, limit);

      if (used.length === 0) {
        tabsTrack.setAttribute('hidden', '');
        return;
      }
      tabsTrack.removeAttribute('hidden');

      used.forEach(function (card) {
        var href = card.getAttribute('href');
        if (!href) return;

        var link = document.createElement('a');
        link.className = 'mm-cat-tab';
        link.href = href;
        link.setAttribute('data-mm-cat-tab', '');
        link.setAttribute('data-handle', card.dataset.handle || '');
        link.setAttribute('aria-label', card.dataset.title || '');

        var thumbEl = card.querySelector('.mm-cat-card__thumb');
        var thumbType = thumbEl ? thumbEl.getAttribute('data-thumb-type') || '' : '';
        var tabIconUrl = thumbEl ? thumbEl.getAttribute('data-tab-icon') || '' : '';
        var tabLucideUrl = thumbEl ? thumbEl.getAttribute('data-tab-lucide') || '' : '';
        var tabInitial = thumbEl ? thumbEl.getAttribute('data-tab-initial') || '' : '';
        var tabKind = thumbEl ? thumbEl.getAttribute('data-tab-kind') || '' : '';
        var media = document.createElement('span');
        media.className = 'mm-cat-tab__media';

        if (thumbType === 'image' && tabIconUrl) {
          if (tabKind === 'brand') {
            media.className += ' mm-cat-tab__media--brand';
            var brandImg = document.createElement('img');
            brandImg.className = 'mm-cat-tab__icon mm-cat-tab__icon--brand';
            brandImg.src = tabIconUrl;
            brandImg.alt = '';
            brandImg.loading = 'lazy';
            brandImg.decoding = 'async';
            media.appendChild(brandImg);
          } else {
            media.className += ' mm-cat-tab__media--lucide';
            var catImg = document.createElement('img');
            catImg.src = tabIconUrl;
            catImg.alt = '';
            catImg.loading = 'lazy';
            catImg.decoding = 'async';
            media.appendChild(catImg);
          }
        } else if (thumbType === 'lucide' && tabLucideUrl) {
          media.className += ' mm-cat-tab__media--lucide';
          var lucideImg = document.createElement('img');
          lucideImg.src = tabLucideUrl;
          lucideImg.alt = '';
          lucideImg.loading = 'lazy';
          lucideImg.decoding = 'async';
          media.appendChild(lucideImg);
        } else if (thumbType === 'brand-pending') {
          media.className += ' mm-cat-tab__media--pending';
          media.textContent =
            tabInitial ||
            (card.dataset.shortTitle || card.dataset.title || '?').charAt(0);
        } else {
          media.className += ' mm-cat-tab__media--pending';
          var ph = document.createElement('span');
          ph.className = 'mm-cat-tab__ph';
          ph.textContent = (card.dataset.shortTitle || card.dataset.title || '?').charAt(0);
          media.appendChild(ph);
        }

        link.appendChild(media);

        var label = document.createElement('span');
        label.className = 'mm-cat-tab__label';
        label.textContent = card.dataset.shortTitle || card.dataset.title || '';
        link.appendChild(label);

        link.addEventListener('click', function () {
          var handle = card.dataset.handle;
          if (!handle) return;
          views = readViews();
          views[handle] = getViewCount(views, handle) + 1;
          writeViews(views);
        });

        tabsTrack.appendChild(link);
      });
    }

    function filterCards(query) {
      var q = (query || '').trim();
      var anyVisible = false;

      cards.forEach(function (card) {
        var hay = card.__mmCatHaystack || buildCardHaystack(card);
        var match = matchesFuzzySearch(q, hay);
        card.hidden = !match;
        if (match) anyVisible = true;
      });

      groups.forEach(function (group) {
        var groupCards = group.querySelectorAll('[data-mm-cat-card]');
        var groupVisible = false;
        groupCards.forEach(function (c) {
          if (!c.hidden) groupVisible = true;
        });
        group.hidden = !groupVisible;
      });

      if (emptyState) {
        emptyState.hidden = anyVisible || !q;
      }

      buildTabs();
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterCards(searchInput.value);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var handle = card.dataset.handle;
        if (!handle) return;
        views = readViews();
        views[handle] = getViewCount(views, handle) + 1;
        writeViews(views);
      });
    });

    var groupTabBtns = null;
    if (groupTabsTrack) {
      groupTabBtns = groupTabsTrack.querySelectorAll('[data-mm-cat-group-tab]');
      if (groupTabBtns.length && !groupTabsTrack.querySelector('.is-active')) {
        groupTabBtns[0].classList.add('is-active');
      }
    }

    buildTabs();

    if (groupTabsTrack && groupTabBtns) {

      function setActiveGroupTab(activeBtn) {
        groupTabBtns.forEach(function (t) {
          t.classList.toggle('is-active', t === activeBtn);
        });
        buildTabs();
      }

      function scrollToGroup(groupId) {
        var target = document.getElementById(groupId);
        if (!target) return;

        scrollLockUntil = Date.now() + 800;
        setActiveGroupTab(
          groupTabsTrack.querySelector('[data-group-id="' + groupId + '"]')
        );

        var anchor = target.querySelector('[data-mm-cat-group-anchor]') || target;
        var headerOff = refreshFixedTop();
        var stickyH =
          parseInt(root.style.getPropertyValue('--mm-cat-sticky-h'), 10) ||
          (stickyBar ? stickyBar.offsetHeight : 140);
        var top = anchor.getBoundingClientRect().top + window.scrollY - headerOff - stickyH - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      groupTabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-group-id');
          if (!id) return;
          scrollToGroup(id);
        });
      });

      if ('IntersectionObserver' in window) {
        var observerStickyH =
          parseInt(root.style.getPropertyValue('--mm-cat-sticky-h'), 10) ||
          (stickyBar ? stickyBar.offsetHeight : 140);
        var groupObserver = new IntersectionObserver(
          function (entries) {
            if (Date.now() < scrollLockUntil) return;

            var visible = entries
              .filter(function (e) {
                return e.isIntersecting;
              })
              .sort(function (a, b) {
                return b.intersectionRatio - a.intersectionRatio;
              });

            if (!visible.length) return;
            var id = visible[0].target.id;
            var match = groupTabsTrack.querySelector('[data-group-id="' + id + '"]');
            if (match) {
              setActiveGroupTab(match);
            }
          },
          {
            root: null,
            rootMargin: '-' + observerStickyH + 'px 0px -45% 0px',
            threshold: [0, 0.1, 0.25]
          }
        );

        groups.forEach(function (g) {
          groupObserver.observe(g);
        });
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-mm-categories-page]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mm-categories-page]');
    if (root) {
      root.dataset.mmCatInit = 'false';
      initSection(root);
    }
  });
})();
